import axios, {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosRequestHeaders,
} from "axios";
import { authClient } from "../auth";
import { loginRequest } from "../authConfig";

const API_BASE_URL =
  process.env.REACT_APP_USE_FAKE_MSAL === "true"
    ? ""
    : process.env.REACT_APP_API_URL ?? window.location.origin;

class HttpClient {
  private instance: AxiosInstance;

  constructor() {
    this.instance = axios.create({
      baseURL: API_BASE_URL,
      headers: { "Content-Type": "application/json" },
    });

    this.instance.interceptors.request.use(async (config) => {
      try {
        if (process.env.REACT_APP_USE_FAKE_MSAL === "true") {
          return config;
        }

        const accounts = authClient.getAccounts();
        if (!accounts.length) return config;

        const tokenResult = await authClient.acquireTokenSilent({
          account: accounts[0],
          ...loginRequest,
        });

        const headers = (config.headers ?? {}) as AxiosRequestHeaders;

        headers.Authorization = `Bearer ${tokenResult.accessToken}`;
        //headers.Authorization = `Bearer ${process.env.REACT_APP_JWT_TOKEN}`; // TODO rimuovere

        config.headers = headers;
      } catch (e) {
        console.warn("Unable to inject MSAL token", e);
      }

      return config;
    });

    this.instance.interceptors.response.use(
      (response) => response,
      (error) => {
        console.error("HTTP Error:", error);
        return Promise.reject(error);
      }
    );
  }

  get(url: string, config?: AxiosRequestConfig) {
    return this.instance.get(url, config);
  }

  post(url: string, data?: unknown, config?: AxiosRequestConfig) {
    return this.instance.post(url, data, config);
  }

  put(url: string, data?: unknown, config?: AxiosRequestConfig) {
    return this.instance.put(url, data, config);
  }

  delete(url: string, config?: AxiosRequestConfig) {
    return this.instance.delete(url, config);
  }
}

export const http = new HttpClient();
